import { SchemaSchedulerV3Service } from './service';
import { QueryEndpointName } from './types';

export const CALENDAR_VIEW_V3_API_QUERY_LIMIT = 500;

export const STANDARD_QUERY_ENDPOINT_NAMES = [
  'GetProvider',
  'ListProviders',
  'ListProvidersMulti',
  'ListMappings',
  'ListCalendarEvents',
  'ListCalendarEventsMulti',
  'ListCalendarEventsByOwner',
  'GetCalendarEvent',
  'ListSchedules',
  'ListBookingSubmissions',
  'GetBookingSubmission',
  'GetOperatory',
  'ListOperatories',
  'ListOperatoriesMulti',
  'GetAppointmentType',
  'ListAppointmentTypes',
  'ListAppointmentTypesMulti',
  'FeatureFlagStatus',
  'ListCalendarAvailabilities',
  'ListSourceTenants',
  'ListLocationSettings',
  'GetWaitlistInvitationDetails',
] as const satisfies (keyof typeof SchemaSchedulerV3Service)[];
export const INFINITE_QUERY_ENDPOINT_NAMES = [
  'ListAppointmentTypesMulti',
  'ListAppointmentTypes',
  'ListProviders',
  'ListProvidersMulti',
  'ListBookingSubmissions',
  'ListCalendarEventsByAttendee',
] as const satisfies (keyof typeof SchemaSchedulerV3Service)[];
export const QUERY_ENDPOINT_NAMES = [...STANDARD_QUERY_ENDPOINT_NAMES, ...INFINITE_QUERY_ENDPOINT_NAMES] as const;

export const MUTATION_ENDPOINT_NAMES = [
  'ArchiveProvider',
  'CreateProvider',
  'UpdateProvider',
  'DeleteProviders',
  'CreateMappings',
  'DeleteMappings',
  'CreateCalendarEvent',
  'UpdateCalendarEvent',
  'UpdateCalendarEventStatus',
  'CreateSchedule',
  'UpdateSchedule',
  'DeleteSchedules',
  'CreateBookingSubmission',
  'UpdateBookingSubmission',
  'DeleteBookingSubmission',
  'CreateOperatory',
  'UpdateOperatory',
  'DeleteOperatories',
  'CreateAppointmentType',
  'UpdateAppointmentType',
  'DeleteAppointmentTypes',
  'AppointmentWriteBack',
  'AppointmentStatusWriteBack',
  'PersonWriteBack',
  'CreateLocationSettings',
  'UpdateLocationSettings',
  'BulkUpdateAppointmentTypesColors',
  'DeleteCalendarsEvent',
  'SendWaitlistInvitations',
  'ConfirmWaitlistInvitation',
] as const satisfies (keyof Omit<typeof SchemaSchedulerV3Service, QueryEndpointName>)[];
